import { z } from 'zod';
import { jCommentListSchema } from './comment';
import { jFileLittleSchema } from './file';
import { socialActionSchema, socialActionSchema_deprecated } from './global';
import { jUserLittleSchema } from './user';

export const userResponseStatusSchema = z.union([
    z.literal(1),
    z.literal('onSpot'),
    z.literal('visio'),
    z.literal('available'),
    z.literal('unavailable'),
    z.literal('unknown'),
    z.literal(0),
]);
export type UserResponseStatus = z.infer<typeof userResponseStatusSchema>;

const socialEventRecordSchema = z.object({
    userResponseStatus: userResponseStatusSchema,
    subscribersTotal: z.number(),
    subscribeAction: socialActionSchema_deprecated,
    subscribers: jUserLittleSchema.array(),
});
export type socialEventRecord = z.infer<typeof socialEventRecordSchema>;

export const extendSchema = z.object({
    actions: socialActionSchema.array().optional(),
    comments: jCommentListSchema
        .and(z.object({ _extend: z.object({ actions: socialActionSchema.array().optional() }) }))
        .array()
        .optional(),
    attachments: jFileLittleSchema.array().optional(),
    licenses: z.union([z.literal('1'), z.literal('0')]).optional(),
    licensesExtrabot: z
        .object({
            active: z.boolean(),
            monthRequestsMax: z.number(),
            monthRequestsHit: z.number(),
        })
        .optional(),
    socialEventRecord: socialEventRecordSchema,

    /**
     * TODO : Refactor extended properties typing to use this schema and the xxxWithExtensions types (see withExtensions.ts).
     */
    search: z.never(),
    bookmark: z.never(),
    contact: z.never(),
    quizFieldDefinitions: z.never(),
    quizResponseRecord: z.never(),
    surveyDateRecord: z.never(),
});

export const formatExtensionSchema = extendSchema.keyof().array();
export type FormatExtension = z.infer<typeof formatExtensionSchema>;
